"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { env } from "~/setup/env";
import type { JobadComponentProps } from "~/types/job";
export default function AboutEonUk(_props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      backgroundImage: `url(${env.NEXT_PUBLIC_ASSET_URL}images/jobad/company-bg.webp)`,
      backgroundSize: "cover",
      backgroundPosition: "right"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const bgStyle = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="p-8 text-primary-foreground md:p-10" style={bgStyle}><p>Explore how we support and reward our people with our{" "}<CustomLink blank={true} className="font-semibold underline underline-offset-2 hover:opacity-80" href="https://www.eon-uk-careers.com/en/life-at-eon/we-have-market-leading-benefits.html">market-leading benefits</CustomLink>.</p></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="outer-container py-container text-xl print:hidden" id="about"><div className="inner-container grid gap-6 md:grid-cols-2">{t1}<div className="p-8 text-primary-foreground md:p-10" style={bgStyle}><p>Find out how our{" "}<CustomLink blank={true} className="font-semibold underline underline-offset-2 hover:opacity-80" href="https://www.eon-uk-careers.com/en/life-at-eon/we-are-flexible.html">flexible ways of working</CustomLink>{" "}help you thrive at work and in life.</p></div></div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}